import { jsx as _jsx } from "react/jsx-runtime";
import { CodeListing } from '@criteria-labs/react-typography';
export function ExampleView({ value }) {
    const content = JSON.stringify(value, null, '  ');
    return _jsx(CodeListing, { language: "json", code: content });
}
